import { render, staticRenderFns } from "./InitializeAlisonDesktop.vue?vue&type=template&id=9d9f616c&scoped=true"
import script from "./InitializeAlisonDesktop.vue?vue&type=script&lang=js"
export * from "./InitializeAlisonDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9f616c",
  null
  
)

export default component.exports